import clsx from 'clsx'
import { PropsWithChildren } from 'react'
import styles from './index.module.sass'
import VirtualScroll from '@components/VirtualScroll'

interface Props {
  className?: string;
  anchor?: (index: number) => string;
}

const LiveProductList = ({ className, anchor, children }: PropsWithChildren<Props>) => {
  return (
    <VirtualScroll
      className={clsx(className, styles.liveProductList)}
      rowHeight={100}
      rootMargin="500px"
      anchor={anchor}
    >
      {children}
    </VirtualScroll>
  )
}

export default LiveProductList
